import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import get from 'lodash.get';
import { push } from 'react-router-redux';

import { fetchPayout } from 'modules/payout';

import Messages from 'components/Messages';
import LoadingOverlay from 'components/LoadingOverlay';
import Pagination from 'components/Pagination';
import Item from './item';

class PayoutHistory extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    error: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    payout: PropTypes.array.isRequired,
    totalPages: PropTypes.number.isRequired,
  };

  /**
   * Initial load
   */
  componentWillMount() {
    const { isLoading, dispatch } = this.props;

    // Do not fetch request if request already sent
    if (!isLoading) {
      let page = 1;

      // Check if page params is exists
      if (get(this.props.match, 'params.page')) {
        page = this.props.match.params.page;
      }

      dispatch(fetchPayout({ page }));
    }
  }

  /**
   * Page changes
   */
  componentWillReceiveProps(nextProps) {
    // Check if page params is exists
    if (get(nextProps.match, 'params.page')) {
      const { isLoading, dispatch, match } = this.props;
      const page = nextProps.match.params.page;

      // Make sure page is different
      if (page !== match.params.page) {
        // Do not fetch request if request already sent
        if (!isLoading) {
          dispatch(fetchPayout({ page }));
        }
      }
    }
  }

  onPageChange = (props) => {
    const page = props.selected + 1;
    this.props.dispatch(push(`/funds/page/${page}`));
  };

  renderTable() {
    const { payout } = this.props;

    if (payout.length > 0) {
      return (
        <table className="payout-history-table custom-table">
          <thead>
            <tr>
              <th> ID </th>
              <th> Tanggal </th>
              <th> Nominal </th>
              <th> Status </th>
            </tr>
          </thead>
          <tbody>
            {payout.map(data => <Item key={data.ID} data={data} />)}
          </tbody>
        </table>
      );
    }
    return (
      <Messages> Anda belum pernah melakukan penarikan saldo </Messages>
    );
  }

  render() {
    const { isLoading, totalPages, match } = this.props;
    const showLoading = isLoading ? 'show' : '';
    let page = 1;

    // Check for page params
    if (get(match, 'params.page')) {
      page = parseInt(match.params.page, 10);
    }

    return (
      <div className={`form-wrapper main-content content-wrapper ${showLoading}`}>
        <div className="form-wrapper__inner grid">
          <div className="entry-header">
            <h3 className="block-title"> Riwayat Penarikan Saldo </h3>
          </div>

          {!isLoading && this.renderTable()}

          <Pagination
            totalPages={totalPages}
            initialPage={page - 1}
            onPageChange={this.onPageChange}
          />
        </div>

        <LoadingOverlay />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    isLoading, error, errors, payout, totalPages,
  } = state.payout;
  return {
    isLoading, error, errors, payout, totalPages,
  };
};

export default withRouter(connect(mapStateToProps)(PayoutHistory));



// WEBPACK FOOTER //
// ./src/pages/Funds/PayoutHistory/index.js